import React from 'react'; //{ useEffect, useState, useRef }
// import MapControl from '../components/Controls/mapControl';

function MRMSMapPage() {

    // const MapDetailData = window.MapDetailData;
    // let state = {
    //     options: {
    //         gestureHandling: 'none',
    //         zoomControl: false,
    //     },
    // }
    
    return (
        // <MapControl options={state.options}  MapDetailData={MapDetailData}/>
        <><b>Page is Work in Progress</b></>
    );
}

export default MRMSMapPage;